var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_111_172418)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#36A7F5",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111_172418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111_172418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 17.4C18.2113 17.4 18.3864 17.3307 18.5255 17.192C18.6642 17.0529 18.7335 16.8778 18.7335 16.6667V14.05C18.7335 13.8389 18.6642 13.6667 18.5255 13.5333C18.3864 13.4 18.2113 13.3333 18.0002 13.3333C17.7891 13.3333 17.6142 13.4027 17.4755 13.5413C17.3364 13.6805 17.2669 13.8556 17.2669 14.0667V16.6833C17.2669 16.8833 17.3364 17.0529 17.4755 17.192C17.6142 17.3307 17.7891 17.4 18.0002 17.4ZM18.0002 12.0833C18.2113 12.0833 18.3891 12.0111 18.5335 11.8667C18.678 11.7222 18.7502 11.5445 18.7502 11.3333C18.7502 11.1222 18.678 10.9445 18.5335 10.8C18.3891 10.6556 18.2113 10.5833 18.0002 10.5833C17.7891 10.5833 17.6113 10.6556 17.4669 10.8C17.3224 10.9445 17.2502 11.1222 17.2502 11.3333C17.2502 11.5445 17.3224 11.7222 17.4669 11.8667C17.6113 12.0111 17.7891 12.0833 18.0002 12.0833ZM18.0002 20.8C17.0558 20.8 16.1695 20.6222 15.3415 20.2667C14.514 19.9111 13.7946 19.4278 13.1835 18.8167C12.5724 18.2056 12.0891 17.4862 11.7335 16.6587C11.378 15.8307 11.2002 14.9445 11.2002 14C11.2002 13.0556 11.378 12.1693 11.7335 11.3413C12.0891 10.5138 12.5724 9.79446 13.1835 9.18335C13.7946 8.57223 14.514 8.0889 15.3415 7.73335C16.1695 7.37779 17.0558 7.20001 18.0002 7.20001C18.9446 7.20001 19.8309 7.37779 20.6589 7.73335C21.4864 8.0889 22.2058 8.57223 22.8169 9.18335C23.428 9.79446 23.9113 10.5138 24.2669 11.3413C24.6224 12.1693 24.8002 13.0556 24.8002 14C24.8002 14.9445 24.6224 15.8307 24.2669 16.6587C23.9113 17.4862 23.428 18.2056 22.8169 18.8167C22.2058 19.4278 21.4864 19.9111 20.6589 20.2667C19.8309 20.6222 18.9446 20.8 18.0002 20.8ZM18.0002 19.2833C19.4669 19.2833 20.7142 18.7696 21.7422 17.742C22.7698 16.714 23.2835 15.4667 23.2835 14C23.2835 12.5333 22.7698 11.286 21.7422 10.258C20.7142 9.23046 19.4669 8.71668 18.0002 8.71668C16.5335 8.71668 15.2864 9.23046 14.2589 10.258C13.2309 11.286 12.7169 12.5333 12.7169 14C12.7169 15.4667 13.2309 16.714 14.2589 17.742C15.2864 18.7696 16.5335 19.2833 18.0002 19.2833Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_111_172418",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.68 0 0 0 0 0.68 0 0 0 0 0.68 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_172418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_172418",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7f7a1ed301e37765ae4d251ca684118b.svg";
export { ForwardRef as ReactComponent };